import { AuditEntityType, UserEmploymentStatusDto, UserFiredStatusDto } from '@sr/dto';
import { userApi } from 'entities/user/api';
import { invalidateEntityAudit } from 'entities/audit/utils';


const injectedApi = userApi.injectEndpoints({
  endpoints: (builder) => ({
    getUserFiredStatus: builder.query<UserFiredStatusDto, number>({
      query: (userId: number) => `users/${userId}/fired-status`
    }),
    getEmploymentStatus: builder.query<UserEmploymentStatusDto, number>({
      query: (userId: number) => `users/${userId}/employment-status`
    }),
    updateUserFiredStatus: builder.mutation<UserFiredStatusDto, { userId: number, data: UserFiredStatusDto }>({
      query: ({ userId, data }) => (
        {
          url: `users/${userId}/fired-status`,
          body: data,
          method: 'PUT'
        }),
      async onQueryStarted({ userId }, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;
          invalidateEntityAudit(dispatch, AuditEntityType.USER, userId);
        } catch (error) {
          console.error(error);
        }
      },
    })
  }) });

export const userFiredStatusApi = injectedApi.enhanceEndpoints({
  addTagTypes: ['userFireStatus', 'userList'],
  endpoints: {
    getUserFiredStatus: {
      providesTags: (result, _, userId) => (
        result ? [{ type: 'userFireStatus', id: userId }] : ['userFireStatus']
      )
    },
    updateUserFiredStatus: {
      invalidatesTags: (res, error, query) => (
        res && !error ? [{ type: 'userFireStatus', id: query.userId }, 'userList'] : ['userFireStatus']
      )
    },
    getEmploymentStatus: {
      providesTags: (result, error, userId) => (
        result ? [{ type: 'userFireStatus', id: userId }] : ['userFireStatus']
      )
    }
  }
});

